/*
 * Author: Roger
 * File Created: Wednesday, 24-08-07 11:08 am
 * Last Modified: Wednesday, 24-09-04 05:50 pm, by Roger
 */
'use client';
import { motion } from 'framer-motion';

import Limitless from './Limitless';

import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

import Controls from './Controls';
import Country from './Country';
import Crypto from './Crypto';
import Depoint from './Depoint';
import Earn from './Earn';
import Network from './Network';
import Pay from './Pay';
import Reward from './Reward';
import Withdraw from './Withdraw';

const Icons = {
  Country,
  Crypto,
  Depoint,
  Earn,
  Limitless,
  Network,
  Pay,
  Reward,
  Withdraw,
  Controls,
};

export type IconName = keyof typeof Icons;

interface LandingIconProps extends SvgIconProps {
  name: IconName;
}

const LandingIcon: React.FC<LandingIconProps> = ({ name, ...svgProps }) => {
  const Svg = Icons[name as IconName];

  return (
    <motion.div
      initial={{ scale: 1 }}
      transition={{ duration: 0.2 }}
      whileHover={{ scale: 1.2 }}
      whileTap={{ scale: 0.8 }}>
      <SvgIcon inheritViewBox {...svgProps}>
        <Svg />
      </SvgIcon>
    </motion.div>
  );
};

export default LandingIcon;
